import { routeName } from '@/constants/routeName';
/**
 * 페이지진입시 허브 셀렉터를 활성,비활성 여부 판단
 * 이것과 src/constants/hubSelectorTypeMapper.ts 역할이 겹침.
 * hubSelectorTypeMapper.ts는 진입 후에 조건을 판단하여 비활성화할지 여부다.
 * 일원화 되어야 한다.
 *
 * 총판 유저만 허브셀렉터 활성.
 * 타허브선택권한이 있어도 총판이 아니면 비활성 되어야 하는 메뉴가 존재함.
 * 대표적으로 기사수익이 있다. 타허브조회 권한이 있어도 이 메뉴는 타 허브를 볼 수 없음
 *
 * true => 허브 셀렉터 비활성
 * false => 허브 셀렉터 활성
 */
const possibleOnlyDistUser = (store) => {
    const isDistUser = store.getters['user/isDistUser'];
    if (!isDistUser) {
        return true;
    }
    return false;
};
const initData = {
    [routeName.WELCOME]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.BAROGO_NOTICE]: () => true,
    [routeName.MEMBER_COMPANY_INQUIRY]: () => true,
    // 총판점 공지사항
    [routeName.DISTRIBUTOR_NOTICE]: () => true,
    [routeName.DISTRIBUTOR_NOTICE_CREATE]: () => true,
    [routeName.DISTRIBUTOR_NOTICE_EDIT]: () => true,
    [routeName.DISTRIBUTOR_NOTICE_DETAIL]: () => true,
    // 회원사 업무문의
    [routeName.MEMBER_COMPANY_INQUIRY]: () => true,
    [routeName.MEMBER_COMPANY_INQUIRY_CREATE]: () => true,
    [routeName.MEMBER_COMPANY_INQUIRY_DETAIL]: () => true,
    [routeName.MEMBER_COMPANY_INQUIRY_EDIT]: () => true,
    // 라이더 공지사항
    [routeName.WORKER_NOTICE]: () => true,
    [routeName.WORKER_NOTICE_CREATE]: () => true,
    [routeName.WORKER_NOTICE_DETAIL]: () => true,
    [routeName.WORKER_NOTICE_EDIT]: () => true,
    // 상점 업무 처리
    [routeName.STORE_WORK_PROCESS]: () => true,
    [routeName.STORE_WORK_PROCESS_DETAIL]: () => true,
    [routeName.STORE_WORK_PROCESS_CREATE]: () => true,
    [routeName.STORE_WORK_PROCESS_CREATE_REPLY]: () => true,
    [routeName.STORE_WORK_PROCESS_EDIT]: () => true,
    [routeName.STORE_WORK_PROCESS_EDIT_REPLY]: () => true,
    // 캐쉬 이동 설정
    [routeName.BAROMONEY_TRANSFER_SETTING]: () => true,
    [routeName.BAROMONEY_TRANSFER_SETTING_DETAIL]: () => false,
    // 세부지명 요청
    [routeName.REQUEST_MAP]: () => true,
    [routeName.REQUEST_MAP_CREATE]: () => true,
    [routeName.REPORT_DOWNLOAD]: () => true,
    [routeName.BAROMONEY_TRANSFER_SETTING]: () => true,
    [routeName.BAROMONEY_ACCOUNT_RECEIVABLE_LIST]: () => true,
    [routeName.BAROMONEY_ACCRUED_EXPENSES_LIST]: () => true,
    [routeName.DELIVERY_HISTORY]: ({ store }) => {
        const isPermissionOtherHub = store.getters['user/isPermissionOtherHub'];
        const isDistUser = store.getters['user/isDistUser'];
        if (isDistUser || isPermissionOtherHub) {
            return false;
        }
        return true;
    },
    // eslint-disable-next-line arrow-body-style
    [routeName.OPERATION_SETTING]: () => {
        // const isPermissionOtherHub = store.getters['user/isPermissionOtherHub'];
        // const isDistUser = store.getters['user/isDistUser'];
        // if (isDistUser || isPermissionOtherHub) {
        //   return false;
        // }
        // return true;
        return true;
    },
    [routeName.MAP_CONTROL]: ({ store }) => {
        const isPermissionOtherHub = store.getters['user/isPermissionOtherHub'];
        const isDistUser = store.getters['user/isDistUser'];
        if (isDistUser || isPermissionOtherHub) {
            return false;
        }
        return true;
    },
    [routeName.LIST_CONTROL]: ({ store }) => {
        const isPermissionOtherHub = store.getters['user/isPermissionOtherHub'];
        const isDistUser = store.getters['user/isDistUser'];
        if (isDistUser || isPermissionOtherHub) {
            return false;
        }
        return true;
    },
    [routeName.STORE_ADJUSTMENT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.STORE_ADJUSTMENT_DETAIL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.STORE_MANAGEMENT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.STORE_MANAGEMENT_CREATE]: () => true,
    [routeName.STORE_MANAGEMENT_DETAIL]: () => true,
    [routeName.STORE_MANAGEMENT_EDIT]: () => true,
    [routeName.STORE_MANAGEMENT_EDIT_BASIC_INFO]: () => true,
    [routeName.STORE_MANAGEMENT_EDIT_FEE_SETTING]: () => true,
    [routeName.STORE_MANAGEMENT_EDIT_OPERATION_SETTING]: () => true,
    /** 상점 통계 */
    [routeName.STORE_STATS]: () => true,
    [routeName.STORE_STATS_DAILY]: () => true,
    [routeName.STORE_STATS_HOURLY]: () => true,
    [routeName.STORE_STATS_DAY_OF_WEEK]: () => true,
    [routeName.STORE_STATS_MONTHLY]: () => true,
    [routeName.STORE_STATS_SHARE_STORE]: () => true,
    /** 허브 통계 */
    [routeName.HUB_STATS]: () => true,
    [routeName.HUB_STATS_DAILY]: () => true,
    [routeName.HUB_STATS_DAY_OF_WEEK]: () => true,
    [routeName.HUB_STATS_MONTHLY]: () => true,
    [routeName.WORKER_MANAGEMENT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_BAROMONEY_HISTORY]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_PROFIT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_MONTHLY_ATTENDANCE]: () => false,
    [routeName.WORKER_MANAGEMENT_WORKER_CREATE]: () => true,
    [routeName.WORKER_MANAGEMENT_WORKER_DETAIL]: () => true,
    [routeName.WORKER_MANAGEMENT_WORKER_EDIT]: () => true,
    [routeName.WORKER_MANAGEMENT_WORKER_EDIT_WORK_INFO]: () => true,
    [routeName.WORKER_MANAGEMENT_WORKER_EDIT_DELIVERY_SETTING]: () => true,
    [routeName.WORKER_MANAGEMENT_WORKER_EDIT_PRIVATE_INFO]: () => true,
    [routeName.HUB_MANAGEMENT]: () => true,
    [routeName.HUB_MANAGEMENT_CREATE]: () => true,
    [routeName.HUB_MANAGEMENT_DETAIL]: () => true,
    [routeName.HUB_MANAGEMENT_EDIT]: () => true,
    [routeName.HUB_MANAGEMENT_EDIT_BASIC_INFO]: () => true,
    [routeName.HUB_MANAGEMENT_EDIT_WORKER_OPERATION_SETTING]: () => true,
    [routeName.HUB_MANAGEMENT_EDIT_ADJUSTMENT_OPERATION_SETTING]: () => true,
    [routeName.HUB_ADJUSTMENT_MAIN]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.HUB_ADJUSTMENT_DAILY_SALES]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.HUB_ADJUSTMENT_DAILY_SALES_DETAIL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.HUB_ADJUSTMENT_DAILY_PURCHASE]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.HUB_ADJUSTMENT_TEST_MODE_ENTRANCE]: () => true,
    [routeName.WITHHOLD_TAX_REPORT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.SIMPLE_PAYMENT_DETAIL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.PAYMENT_DETAIL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.DETAILS_PER_WORKER]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_INFORMATION_DETAIL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.BAROMONEY_REPORT_BASIC]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.USER_MANAGEMENT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.USER_MANAGEMENT_CREATE]: () => true,
    [routeName.USER_MANAGEMENT_PAGE]: () => true,
    [routeName.SHARE_MANAGEMENT]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.SHARE_MANAGEMENT_CONFIG]: () => true,
    [routeName.DELIVERY_CHARGE_AREA_CONTROL]: ({ store }) => possibleOnlyDistUser(store),
    [routeName.WORKER_ALLOCATE]: () => true,
    [routeName.LOCATION_CONTROL]: () => true,
    /** 매출 */
    [routeName.SALES]: () => true,
    [routeName.SALES_HUB_BAROMONEY]: () => true,
    [routeName.SALES_HUB_BAROMONEY_DAILY_DETAIL]: () => true,
    [routeName.SALES_STORE_BAROMONEY]: () => true,
    [routeName.SALES_STORE_BAROMONEY_DAILY_DETAIL]: () => true,
    [routeName.SALES_INVOICE]: () => true,
    [routeName.DESIGN_SYSTEM_TEXT]: () => true,
    [routeName.DESIGN_SYSTEM_FORM]: () => true,
    [routeName.DESIGN_SYSTEM_BUTTON]: () => true,
    // 싸이프레스 시 통일된 페이지 전환을 위해 아래와 같이 제공함. (2023.5.22. 하준)
    // 이는 검사시 동일한 페이지로 이동하는 것을 권장하지 않는 부분을 해소하기 위함.
    // 임시 페이지는 pageType 2가 될 것(총판계정의 경우 총판까지 선택 가능 권한이 있는경우 타 허브 선택 가능).
    [routeName.TEMPORARY]: ({ store }) => {
        const isPermissionOtherHub = store.getters['user/isPermissionOtherHub'];
        const isDistUser = store.getters['user/isDistUser'];
        if (isDistUser || isPermissionOtherHub) {
            return false;
        }
        return true;
    },
    [routeName.VALIDATION_COMPOSITION_API]: () => true,
    [routeName.VALIDATION_OPITION_API]: () => true,
};
// 허브 셀렉터의 최초 비활성화 여부를 설정한다.
const hubSelectorDisabler = ({ next, to, store, pStore, }) => {
    const currentRouteName = to.name;
    let isDisabled = false;
    try {
        if (!initData[currentRouteName]) {
            throw new Error(`[hub-selector-disabler]Not Exist hubSelector Middleware. routeName: ${currentRouteName}`);
        }
        isDisabled = initData[currentRouteName]({
            next,
            to,
            store,
            pStore,
        });
    }
    catch (error) {
        console.log('[hubSelector] Error', error);
    }
    store.dispatch('hubSelector/setHubSelectorDisabled', isDisabled);
    return next();
};
export default hubSelectorDisabler;
